<div class="lottery-popup-wrapper">
  <img lib-amdocs-image-version class="lottery-popup-img" src="assets/icons/learning_popup.svg">
  
  <div class="text-small-normal lottery-popup-description">
    
  </div>
  <div class="label-h4 lottery-popup-title">
    {{amdocsContentConstant?.learningPopup.title}}
  </div>
  <div class="text-small-normal lottery-popup-description">
    
  </div>
  <div class="lottery-popup-btn-wrapper">
    <button class="btn btn-medium primary send-notifications-btn"
            (click)="close()">
      {{amdocsContentConstant?.learningPopup.button}}
    </button>
  </div>
</div>
